module.exports = __webpack_public_path__ + "static/media/angieveguilla-12 copy.19c62dc6.jpg";